import React from 'react';

import FooterImage from '../_assets/footer.svg?react';

export type FooterProps = {
  // Empty
};

export const Footer: React.FC<FooterProps> = () => {
  return (
    <div className="relative isolate mt-56">
      <div className="h-32 bg-[#74C6FD] md:h-40 min-[75rem]:h-20" />
      <FooterImage className="absolute bottom-24 left-1/6 h-auto max-w-2/3 sm:bottom-20 md:bottom-28 lg:right-1/6 lg:left-auto min-[75rem]:bottom-10" />
    </div>
  );
};
